











































require("@/assets/css/admin-card.scss");
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class UserListCard extends Vue{
    categoryColor:string = "#999";    
}
